import { render, staticRenderFns } from "./DemoScenariosDialog.vue?vue&type=template&id=4531f024"
import script from "./DemoScenariosDialog.vue?vue&type=script&lang=js"
export * from "./DemoScenariosDialog.vue?vue&type=script&lang=js"
import style0 from "./DemoScenariosDialog.vue?vue&type=style&index=0&id=4531f024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports